// pipe (scan intake): Receiving Intake sidebar entry (links to /ops/intake). Cloned from
// ops-button.tsx (verbatim shape — same ungated rendering; the Core API re-checks every request
// and the route itself mounts under the ERP scope boundary) — only the route, the active-path
// prefix, the icon, the label key, and the testid differ.
import { useI18n } from '@affine/i18n';
import { ImportIcon } from '@blocksuite/icons/rc';
import { useServices } from '@toeverything/infra';

import { MenuLinkItem } from '../../modules/app-sidebar/views';
import { WorkbenchService } from '../../modules/workbench';
import { useNavPrefixActive } from './use-nav-prefix-active';

export const IntakeButton = () => {
  const t = useI18n();
  const { workbenchService } = useServices({ WorkbenchService });
  const workbench = workbenchService.workbench;
  const active = useNavPrefixActive(workbench, '/ops/intake');

  return (
    <MenuLinkItem icon={<ImportIcon />} active={active} to={'/ops/intake'}>
      <span data-testid="pipe-intake-nav">
        {t['com.affine.pipe.intake.nav']()}
      </span>
    </MenuLinkItem>
  );
};
